import { createContext, useState } from "react";

const UserManagementContext = createContext({});

export const UserManagementProvider = ({ children }) => {
  const [tabs, setTabs] = useState(1);

  return (
    <UserManagementContext.Provider value={{ tabs, setTabs }}>
      {children}
    </UserManagementContext.Provider>
  );
};

export default UserManagementContext;
